import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21563cf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview-box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ws_mb16 ws_mt16" }
const _hoisted_5 = { class: "ws_mb16" }
const _hoisted_6 = { class: "ws_mb16" }
const _hoisted_7 = { class: "ws_mb16" }
const _hoisted_8 = { class: "ws_mb16" }
const _hoisted_9 = { class: "ws_mb16" }

import { ref, watch } from 'vue'
import { CODE_ENUM, FILES_TYPE } from '@/common'
import { queryFileDetail } from '@/api'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'preview-modal',
  props: ['visible', 'data'],
  emits: ['update:visible'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

const previewData: any = ref({})

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryDetail()
    }
  }
)

const formatterTime = (time: any) => {
  return moment(time).format('YYYY-MM-DD HH:mm:ss')
}

const loading = ref(false)
const queryDetail = async () => {
  const id = props?.data?.id
  loading.value = true
  const res: any = await queryFileDetail({
    id,
  }).finally(() => {
    loading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    previewData.value = res.data
  }
}

const handleClose = () => {
  $emit('update:visible')
  previewData.value = {}
}

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: props.visible,
    title: "预览",
    width: "530",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(FILES_TYPE).IMAGE === previewData.value.type)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: previewData.value.previewUrl,
              alt: ""
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (_unref(FILES_TYPE).VIDEO === previewData.value.type)
          ? (_openBlock(), _createElementBlock("video", {
              key: 1,
              src: previewData.value.previewUrl,
              controls: ""
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_4, "文件名称：" + _toDisplayString(previewData.value.name), 1),
        _createElementVNode("p", _hoisted_5, "文件类型 : " + _toDisplayString(previewData.value.typeValue), 1),
        _createElementVNode("p", _hoisted_6, "内容类型 : " + _toDisplayString(previewData.value.contentTypeValue), 1),
        _createElementVNode("p", _hoisted_7, "文件大小 : " + _toDisplayString(previewData.value.sizeStr), 1),
        _createElementVNode("p", _hoisted_8, " 采集时间 : " + _toDisplayString(formatterTime(previewData.value.createDate)), 1),
        _createElementVNode("p", _hoisted_9, "经纬度 : " + _toDisplayString(previewData.value.location), 1),
        _createElementVNode("p", null, "设备SN : " + _toDisplayString(previewData.value.deviceSn), 1)
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})